import { useMutation } from "@apollo/client/react";import { useState } from "react";

import { CustomDialog } from "../../../../../components/customDialog/CustomDialog";
import UPDATE_ASIGNACION_PROFESIONAL from "../../../../../data/graphQL/mutations/GestionAsistencial/updateAsignacionProfesional";
import toast from 'react-hot-toast';
import { Grid } from "@mui/material";
import adaptEvaluacionProfesionalGrillaArray from "../../../../../data/graphQL/queries/GestionAsistencial/getEvaluacionProfesionalGrilla";
import { DateInput } from "../../../../../components/dateInput/DateInput";
import moment from "moment";

export function TabProfesionalUpdateFrecuenciaDialog({
  open,
  handleCloseDialog,
  evaluacionSelected,
  refetchEvaluacionProfesional,
  setEvaluacionProfesional,
  evaluacionProfesionalFrecuencia
}) {
  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState({
    fechaDesde: evaluacionProfesionalFrecuencia.fechaDesde,
    fechaHasta: evaluacionProfesionalFrecuencia.fechaHasta
  });

  const handleChange = async (name, value) => {
    if (name == 'fechaHasta') {
      setFormValues((prev) => ({
        ...prev,
        fechaHasta: moment(value, "YYYY-MM-DD", true).isValid() ? moment(value).format("YYYY-MM-DD") : ""
      }));
    } else {
      setFormValues((prev) => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const [updateAsignacionProfesional] = useMutation(UPDATE_ASIGNACION_PROFESIONAL, {
    onCompleted: (dataResp) => {
      setLoading(false);
      if (dataResp.updateAsignacionProfesional.success) {
        toast.success("Asignación actualizada con éxito.");
        refetchEvaluacionProfesional().then(({ data }) => {
          setEvaluacionProfesional(adaptEvaluacionProfesionalGrillaArray(data));
        });
        handleCloseDialog();
      } else {
        toast.error(dataResp.updateAsignacionProfesional.error);
      }
    },
    onError: () => {
      toast.error("Error al actualizar la asignación del profesional.");
      setLoading(false);
    }
  });

  const valido = () => {
    if (!formValues.fechaHasta) {
      toast.error("La Fecha Hasta es requerida.");
      return false;
    }

    const fechaHastaNueva = moment(formValues.fechaHasta, "YYYY-MM-DD");
    // no superior a la fecha hasta del contrato
    if (fechaHastaNueva.diff(moment(evaluacionSelected.fechaHasta, "YYYY-MM-DD"), 'days') > 0) {
      toast.error("La Fecha Hasta debe estar dentro del rango del contrato.");
      return false;
    }
    // fecha hasta no menor al día de hoy 
    if (fechaHastaNueva < moment().startOf('day')) {
      toast.error("La Fecha Hasta no puede ser anterior al día de hoy.");
      return false;
    }

    return true;
  };

  const handleAcceptUpdate = () => {
    if (valido()) {
      setLoading(true);
      updateAsignacionProfesional({
        variables: { input: {
            idEvaluacionProfesional: evaluacionProfesionalFrecuencia.idEvaluacionProfesional,
            fechaDesde: formValues.fechaDesde,
            fechaHasta: formValues.fechaHasta,
            esReemplazo: 0,
            idEvaluacionProfesionalOriginal: 0
          } }
      });
    }
  };

  return (
    <CustomDialog
      title="Editar Asignación"
      open={open}
      fullWidth
      maxWidth="sm"
      onCancel={handleCloseDialog}
      onAccept={handleAcceptUpdate}
      cancelText="Cancelar"
      acceptText="Actualizar"
      acceptLoading={loading}
      acceptDisabled={loading}>
      
      <Grid container spacing={3} sx={{ fontSize: '14px' }}>
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
          <strong>Profesional:</strong> {evaluacionProfesionalFrecuencia.profesional}
        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
          <DateInput
            label="Fecha desde"
            disabled={true}
            value={formValues?.fechaDesde} />
          
        </Grid>
        <Grid size={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
          <DateInput
            label="Fecha hasta"
            name="fechaHasta"
            value={formValues?.fechaHasta}
            onChange={(value) => handleChange('fechaHasta', value)} />
          
        </Grid>        
      </Grid>
    </CustomDialog>);

}